import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

interface TransactionResponse {
  data: any[];
  page: number;
  limit: number;
  totalPages: number;
  totalRecords: number;
}


@Injectable({
  providedIn: 'root'
})
export class TransactionService {
  baseUrl = `${environment.BACKEND_URL}/stripe`;
  constructor(private http: HttpClient) { }

 

getUserTransactions(
  userId: string,
  search?: string,
  page: number = 1,
  limit: number = 5,
  date?: string
) {
  const token = localStorage.getItem('authToken');
  let url = `${this.baseUrl}/get-user-transactions/${userId}?page=${page}&limit=${limit}`;

  // Priority: specific date parameter first
  if (date) {
    url += `&date=${encodeURIComponent(date)}`;
  } else if (search && search.trim()) {
    // Just pass the search query as-is to the backend
    // Let the backend handle all the complex date parsing logic
    url += `&search=${encodeURIComponent(search.trim())}`;
  }

  return this.http.get(url, { headers: { Authorization: `Bearer ${token}` } });
}
}

